export interface ApiKeySummary {
  id: string;
  name?: string | null;
  key_prefix: string;
  created_at: number;
  last_used_at?: number | null;
  revoked_at?: number | null;
}

export interface ApiKeyCreatedResponse extends ApiKeySummary {
  api_key: string;
}

const API_BASE = '/api';

const getAuthHeaders = (): Record<string, string> => {
  const token = localStorage.getItem('bearer_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const handleJson = async <T>(response: Response): Promise<T> => {
  if (!response.ok) {
    const raw = await response.text();
    throw new Error(raw || response.statusText);
  }
  const text = await response.text();
  if (!text.trim()) {
    return undefined as unknown as T;
  }
  return JSON.parse(text) as T;
};

export const apiKeysApi = {
  async list(): Promise<ApiKeySummary[]> {
    const response = await fetch(`${API_BASE}/api-keys`, {
      credentials: 'include',
      headers: getAuthHeaders(),
    });
    return handleJson<ApiKeySummary[]>(response);
  },

  async create(name?: string): Promise<ApiKeyCreatedResponse> {
    const response = await fetch(`${API_BASE}/api-keys`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        ...getAuthHeaders(),
      },
      body: JSON.stringify(name ? { name } : {}),
    });
    return handleJson<ApiKeyCreatedResponse>(response);
  },

  async revoke(id: string): Promise<void> {
    const response = await fetch(`${API_BASE}/api-keys/${id}`, {
      method: 'DELETE',
      credentials: 'include',
      headers: getAuthHeaders(),
    });
    await handleJson(response);
  },
};
